import * as React from 'react';
import { jsx } from 'react/jsx-runtime';

// src/scene/GraphDefaults.tsx

// src/share/serialize.ts
function graphShareStateHasContent(state) {
  if (!state) return false;
  return Boolean(
    state.scene?.nodes?.length || state.scene?.edges?.length || state.nodes?.length || state.edges?.length || state.rootIds?.length || state.expanded?.length
  );
}
var GRAPH_DEFAULTS_CONTEXT_KEY = /* @__PURE__ */ Symbol.for("@authe/tx-graph/GraphDefaultsContext");
var GraphDefaultsContext = globalThis[GRAPH_DEFAULTS_CONTEXT_KEY] ??= React.createContext({});
function GraphDefaultsProvider({
  value,
  children
}) {
  const outer = React.useContext(GraphDefaultsContext);
  const merged = React.useMemo(() => ({ ...outer, ...value }), [outer, value]);
  return /* @__PURE__ */ jsx(GraphDefaultsContext.Provider, { value: merged, children });
}
function useGraphDefaults() {
  return React.useContext(GraphDefaultsContext);
}

export { GraphDefaultsProvider, graphShareStateHasContent, useGraphDefaults };
//# sourceMappingURL=defaults.js.map
//# sourceMappingURL=defaults.js.map